import styled from 'styled-components'

import { BREAKPOINTS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const RedemptionShareContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
`

export const RedemptionSocialShareText = styled.div`
  font-family: Druk, sans-serif;
  font-size: 36px;
  line-height: 1.2;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 46px;
  }
`

export const SocialBubbles = styled.img`
  width: 100%;
  margin: 13px 0;
`

export const CopyButton = styled(RoundedButton).attrs({
  variant: 'secondary',
  iconName: 'copy',
})`
  width: 100%;
`

export const ShareButton = styled(RoundedButton).attrs({
  iconName: 'upload',
})`
  width: 100%;
  margin-top: 15px;
`

export const ReturnButton = styled(RoundedButton).attrs({
  variant: 'transparent',
})`
  width: 100%;
  margin-top: 5px;
`
